import type { Auth0Config, SocialLoginConfig } from '@/services/interfaces/Auth';
import { defaultSocialProviders, getEnabledProviders } from './socialProviders';

// 从环境变量获取Auth0配置
export const getAuth0Config = (): Auth0Config => {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  // 🔑 使用专门的回调页面，避免与登录页面冲突
  const redirectUri = import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin + '/auth/callback';

  if (!domain || !clientId) {
    throw new Error('Auth0 configuration is missing. Please check VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID environment variables.');
  }

  return {
    domain,
    clientId,
    redirectUri,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: import.meta.env.VITE_AUTH0_SCOPE || 'openid profile email',
  };
};

// 创建默认社交登录配置
export const createSocialLoginConfig = (
  overrides: Partial<SocialLoginConfig> = {}
): SocialLoginConfig => {
  const auth0Config = getAuth0Config();
  
  return {
    providers: getEnabledProviders(defaultSocialProviders),
    auth0: auth0Config,
    ...overrides,
  };
};

// 验证Auth0配置
export const validateAuth0Config = (config: Auth0Config): boolean => {
  return !!(config.domain && config.clientId && config.redirectUri);
};

// 获取Auth0授权参数
export const getAuth0AuthorizationParams = (provider?: string) => {
  const baseParams = {
    redirect_uri: getAuth0Config().redirectUri,
    scope: getAuth0Config().scope || 'openid profile email',
  };
  
  if (provider) {
    return {
      ...baseParams,
      connection: provider,
      state: `provider_${provider}_${Date.now()}`,
    };
  }
  
  return baseParams;
};

// Auth0错误处理
export const handleAuth0Error = (error: any): string => {
  if (error?.error_description) {
    return error.error_description;
  }
  
  if (error?.message) {
    return error.message;
  }
  
  if (typeof error === 'string') {
    return error;
  }
  
  return 'Authentication failed. Please try again.';
};
